<template>
  <b-modal
    id="modalAdjustSale"
    centered
    title="Sale adjustment"
    title-class="font-18"
    size="md"
    @hide="resetForm"
  >
    <b-tabs v-model="activeTab" nav-class="mb-3">
      <!-- Aba 1 - Ajuste de Pagamento -->
      <b-tab title="Ajuste de Pagamento">
        <div class="mb-3">
          <label for="sale_id" class="form-label">ID da Venda</label>
          <b-form-input
            id="sale_id"
            v-model="sale_id"
            type="number"
            :state="!errorsForm.sale_id"
            placeholder="Digite o ID da venda"
          />
          <b-form-invalid-feedback v-if="errorsForm.sale_id">{{ errorsForm.sale_id }}</b-form-invalid-feedback>
        </div>

        <div class="mb-3">
          <label for="first_digits" class="form-label">Primeiros Dígitos</label>
          <b-form-input
            id="first_digits"
            v-model="first_digits"
            :state="!errorsForm.first_digits"
            placeholder="Ex: 4662"
          />
          <b-form-invalid-feedback v-if="errorsForm.first_digits">{{ errorsForm.first_digits }}</b-form-invalid-feedback>
        </div>

        <div class="mb-3">
          <label for="last_digits" class="form-label">Últimos Dígitos</label>
          <b-form-input
            id="last_digits"
            v-model="last_digits"
            :state="!errorsForm.last_digits"
            placeholder="Ex: 2233"
          />
          <b-form-invalid-feedback v-if="errorsForm.last_digits">{{ errorsForm.last_digits }}</b-form-invalid-feedback>
        </div>

        <div class="mb-3">
          <label for="payment_arrangement_id" class="form-label">ID </label>
          <b-form-input
            id="payment_arrangement_id"
            v-model="payment_arrangement_id"
            type="number"
            :state="!errorsForm.payment_arrangement_id"
            placeholder = "27 Mastercard, 38 Visa"
          />
          <b-form-invalid-feedback v-if="errorsForm.payment_arrangement_id">{{ errorsForm.payment_arrangement_id }}</b-form-invalid-feedback>
        </div>

        <div class="mb-3">
          <label for="account_statement_ids" class="form-label">IDs dos Statements (separados por vírgula)</label>
          <b-form-input
            id="account_statement_ids"
            v-model="account_statement_ids"
            :state="!errorsForm.account_statement_ids"
            placeholder="Ex: 6239406,6239407"
          />
          <b-form-invalid-feedback v-if="errorsForm.account_statement_ids">{{ errorsForm.account_statement_ids }}</b-form-invalid-feedback>
        </div>

        <div class="mb-3">
          <label for="brand" class="form-label">Bandeira</label>
          <b-form-input
            id="brand"
            v-model="brand"
            :state="!errorsForm.brand"
            placeholder="Digite a bandeira (ex: mastercard, visa)"
          />
          <b-form-invalid-feedback v-if="errorsForm.brand">{{ errorsForm.brand }}</b-form-invalid-feedback>
        </div>
      </b-tab>

      <!-- Aba 2 - Comando de Ajuste -->
      <b-tab title="Comando de Ajuste">
        <div class="mb-3">
          <label for="sale_id_command" class="form-label">ID da Venda</label>
          <b-form-input
            id="sale_id_command"
            v-model="sale_id"
            type="number"
            :state="!errorsForm.sale_id"
            placeholder="Digite o ID da venda"
          />
          <b-form-invalid-feedback v-if="errorsForm.sale_id">{{ errorsForm.sale_id }}</b-form-invalid-feedback>
        </div>

        <div class="mb-3">
          <label for="first_digits_command" class="form-label">Primeiros Dígitos</label>
          <b-form-input
            id="first_digits_command"
            v-model="first_digits"
            :state="!errorsForm.first_digits"
            placeholder="Ex: 4662"
          />
          <b-form-invalid-feedback v-if="errorsForm.first_digits">{{ errorsForm.first_digits }}</b-form-invalid-feedback>
        </div>

        <div class="mb-3">
          <label for="last_digits_command" class="form-label">Últimos Dígitos (opcional)</label>
          <b-form-input
            id="last_digits_command"
            v-model="last_digits"
            :state="!errorsForm.last_digits"
            placeholder="Ex: 2233"
          />
          <b-form-invalid-feedback v-if="errorsForm.last_digits">{{ errorsForm.last_digits }}</b-form-invalid-feedback>
        </div>
      </b-tab>
    </b-tabs>

    <template v-slot:modal-footer="{ cancel }">
      <div class="d-flex justify-content-around w-100">
        <b-button @click="cancel">Cancelar</b-button>
        <b-button variant="success" @click="submitData">Concluir</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import AdjustSale from '@services/resources/AdjustSale';
import AdjustSaleCommand from '@services/resources/AdjustSaleCommand';

const adjustSale = AdjustSale.build();
const adjustSaleCommand = AdjustSaleCommand.build();

export default {
  name: 'modalAdjustSale',
  data() {
    return {
      activeTab: 0,
      sale_id: '',
      first_digits: '',
      last_digits: '',
      payment_arrangement_id: '',
      account_statement_ids: '',
      brand: '',
      errorsForm: {},
    };
  },
  methods: {
    validateFields() {
      this.errorsForm = {};
      if (!this.sale_id) this.errorsForm.sale_id = 'O ID da venda é obrigatório.';
      if (!this.first_digits) this.errorsForm.first_digits = 'Os primeiros dígitos são obrigatórios.';

      if (this.activeTab === 0) {
        // Validações para ajuste de pagamento
        if (!this.last_digits) this.errorsForm.last_digits = 'Os últimos dígitos são obrigatórios.';
        if (!this.payment_arrangement_id) this.errorsForm.payment_arrangement_id = 'Informe o arranjo.';
        if (!this.account_statement_ids) this.errorsForm.account_statement_ids = 'Informe os IDs do extrato.';
        if (!this.brand) this.errorsForm.brand = 'Informe a bandeira.';
      }

      return Object.keys(this.errorsForm).length === 0;
    },
    async submitData() {
      if (!this.validateFields()) return;

      try {
        if (this.activeTab === 0) {
          // Ajuste de pagamento
          const payload = {
            sale_id: Number(this.sale_id),
            first_digits: this.first_digits,
            last_digits: this.last_digits,
            payment_arrangement_id: Number(this.payment_arrangement_id),
            account_statement_ids: this.account_statement_ids
              .split(',')
              .map(id => Number(id.trim())),
            brand: this.brand,
          };
          await adjustSale.post('', payload);
        } else {
          // Comando de ajuste
          const payload = {
            sale_id: Number(this.sale_id),
            first_digits: this.first_digits,
            last_digits: this.last_digits,
          };
          await adjustSaleCommand.post('', payload);
        }

        this.$bvToast.toast('Ajuste enviado com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          solid: true,
        });

        this.$bvModal.hide('modalAdjustSale');
        this.resetForm();
      } catch (error) {
        let message = 'Erro ao enviar ajuste';

        if (
          error.response &&
          error.response.status === 422 &&
          typeof error.response.data === 'string'
        ) {
          const parsed = JSON.parse(error.response.data);

          if (parsed.errors) {
            message = Object.values(parsed.errors)
              .flat()
              .join('\n');
          }

        } else if (
          error.response &&
          typeof error.response.data === 'object' &&
          error.response.data.message
        ) {
          message = error.response.data.message;

        } else if (error.message) {
          message = error.message;
        }

        this.$bvToast.toast(message, {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        });
      }
    },
    resetForm() {
      this.activeTab = 0;
      this.sale_id = '';
      this.first_digits = '';
      this.last_digits = '';
      this.payment_arrangement_id = '';
      this.account_statement_ids = '';
      this.brand = '';
      this.errorsForm = {};
    },
  },
};
</script>
